<!--需求来源表-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <a-select
          show-search
          allowClear
          slot="sourceCode"
          :default-active-first-option="true"
          v-model="queryParams.sourceCode"
          option-filter-prop="children"
          option-label-prop="label">
          <a-select-option v-for="(item) in sourceCodeSelectList" :key="item" :value="item" :label="item">
            {{ item }}
          </a-select-option>
        </a-select>
        <global-select
          slot="statusList"
          :value.sync="queryParams.promotionName"
          :selectData="statusList"
          selectType="selectFilter"
          :selectItem="{ value: 'lookupValue', label: 'lookupValue' }"
        />
        <a-range-picker slot="submitTime" v-model="queryParams.submitTime" valueFormat="YYYY-MM-DD" allowClear />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiAnalysisDetailExport" ref="download" />
        <a-button type="primary" @click="handleExport">导出</a-button>
        <a-button type="primary" :loading="loading" @click="handleAllocation">下发</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          @successCallBack="successCallBack"
          @selectedRowChange="selectedRowChange"
          rowKey="billNo"
          :scroll="{ fixScreen: true, x: 1200 }">
          <template slot="dateFormat" slot-scope="data">
            {{ data.text && $moment(data.text).format('YYYY-MM-DD') }}
          </template>
          <template slot="dateFormat2" slot-scope="data">
            {{ data.text && $moment(data.text).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import cloneDeep from 'lodash.clonedeep'
import { apiAnalysisDetailList, apiAnalysisDetailExport, apiAnalysisPushDemand, apiSourceCodeList } from '@/api/scp/pre-order-and-placement/pre-order-and-placement'

export default {
  // eslint-disable-next-line
  name: 'Demand-detail',
  components: { DownloadModal },
  data() {
    return {
      loading: false,
      statusList: [], // 状态
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      sourceCodeSelectList: [], // 来源单据号下拉选择框
      apiAnalysisDetailExport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiAnalysisDetailList, false),
        pageCurrent: true
      },
      // 查询参数
      queryParams: {
        sourceCode: undefined,
        pushDemandIs: undefined,
        submitTime: undefined,
        submitTimeStart: undefined,
        submitTimeEnd: undefined,
        materialNo: undefined,
        projectTeamName: undefined,
        mainModel: undefined,
        promotionName: undefined,
        planUserName: undefined
      },
      // 表格数据
      tableList: [],
      formList: [
        { label: '物料编码', decorator: ['materialNo'], type: 'input' },
        { label: '项目组', decorator: ['projectTeamName'], type: 'input' },
        { label: '主型号', decorator: ['mainModel'], type: 'input' },
        { label: '促销名称', decorator: ['promotionName'], type: 'statusList' },
        { label: '计划员', decorator: ['planUserName'], type: 'input' },
        { label: '提报日期', decorator: ['submitTime'], type: 'submitTime' },
        { label: '是否已转零星', decorator: ['pushDemandIs'], type: 'select', options: [{ key: 1, value: '是' }, { key: 0, value: '否' }] },
        { label: '来源单据号', decorator: ['sourceCode'], type: 'sourceCode' }
      ],
      // 表格字段
      columns: [
        { title: '摆场单号', dataIndex: 'billNo', align: 'center', width: 140 },
        { title: '需求类型', dataIndex: 'demandTypeName', align: 'center', width: 140 },
        { title: '促销名称', dataIndex: 'promotionName', align: 'center', width: 110 },
        { title: '物料编码', dataIndex: 'materialNo', align: 'center', width: 150 },
        { title: '物料名称', dataIndex: 'materialName', align: 'center', width: 120, ellipsis: true },
        { title: '规格描述', dataIndex: 'materialSpec', align: 'center', width: 180, ellipsis: true },
        { title: '计划员', dataIndex: 'planUserName', align: 'center', width: 100, ellipsis: true },
        { title: '主型号', dataIndex: 'mainModel', align: 'center', width: 110 },
        { title: '项目组', dataIndex: 'projectTeamName', align: 'center', width: 120, ellipsis: true },
        { title: '需求数量', dataIndex: 'demandQuantity', align: 'center', width: 100 },
        { title: '需求交期', dataIndex: 'demandDate', align: 'center', width: 100, scopedSlots: { customRender: 'dateFormat' } },
        { title: '订单备注', dataIndex: 'orderRemark', align: 'center', width: 180 },
        { title: '来源单据号', dataIndex: 'sourceCode', align: 'center', width: 180 },
        { title: '提报人', dataIndex: 'submitUserName', align: 'center', width: 100 },
        { title: '提报时间', dataIndex: 'submitTime', align: 'center', width: 100, scopedSlots: { customRender: 'dateFormat' } },
        { title: '修改人', dataIndex: 'updateName', align: 'center', width: 100 },
        { title: '修改时间', dataIndex: 'updateTime', align: 'center', width: 180, scopedSlots: { customRender: 'dateFormat2' } },
        {
          title: '是否已转零星',
          dataIndex: 'pushDemandIs',
          align: 'center',
          width: 110,
          customRender: (text, record) => ({ 0: '否', 1: '是' }[record.pushDemandIs])
        },
        { title: '来源编码', dataIndex: 'parentMaterialNo', align: 'center', width: 160 }
      ]
    }
  },
  created() {
    // 摆场需求差异跳转迭代参数
    if (this.$route?.query?.submitTime) {
      this.queryParams.submitTime = [this.$route.query.submitTime, this.$route.query.submitTime]
    }
    if (this.$route?.query?.promotionName) {
      this.queryParams.promotionName = this.$route.query.promotionName
    }
    this.getLookupList('SCP_PLACEMENT_PROMOTION_NAME', 'statusList')
  },
  mounted() {
    this.getSourceCode();
    this.onSearch();
  },
  methods: {
    // 获取来源单号
    getSourceCode() {
      this.sourceCodeSelectList = []
      apiSourceCodeList().then(res => {
        if (res?.data?.length > 0) {
          this.sourceCodeSelectList = res.data
          this.onSearch()
        }
      })
    },
    // 行选中
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    // 翻页清除选择
    successCallBack() {
      // this.isEdit = false
      // this.currentId = '';
      if (this.$refs?.dataTable) this.$refs.dataTable.onClear(); // 清除选择
    },
    // 下发
    handleAllocation() {
      if (this.selectedRows?.length === 0) {
        return this.$message.warning("请勾选单据进行下发")
      }
      if (this.selectedRows?.find(obj => obj.pushDemandIs !== 0)) {
        return this.$message.warning("只能下发未转零星的数据")
      }
      const self = this
      this.$confirm({
        title: `提示`,
        content: '确定下发选中数据？',
        okText: '确定',
        cancelText: '取消',
        onOk () {
          const billNoList = self.selectedRows.map(obj => obj.billNo)
          self.loading = true
          apiAnalysisPushDemand(billNoList).then(response => {
            if (response.code === 200) {
              self.$message.success('下发成功')
              self.onSearch()
            } else {
              self.$message.error(response?.msg)
            }
          }).finally(() => {
            self.loading = false
          })
        }
      })
    },
    // 获取快码
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        if (response.rows?.length > 0) {
          this[arr] = response.rows
        }
      })
    },
    // 表单搜索
    onSearch(value = {}) {
      const params = Object.assign({}, this.queryParams, value)
      params.submitTimeStart = params.submitTime && params.submitTime[0] ? (params.submitTime[0] + " 00:00:00") : ""
      params.submitTimeEnd = params.submitTime && params.submitTime[1] ? (params.submitTime[1] + " 23:59:59") : ""
      delete params.searchFormLabel
      const queryObj = cloneDeep(params)
      if (queryObj?.submitTime) { delete queryObj.submitTime }
      this.$refs.dataTable.searchParams = queryObj
      this.$refs.dataTable.getData()
    },
    // 新增/修改框事件
    handleOk() {
      this.onSearch()
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        submitTime: undefined,
        submitTimeStart: undefined,
        submitTimeEnd: undefined,
        materialNo: undefined,
        projectTeamName: undefined,
        mainModel: undefined,
        promotionName: undefined,
        planUserName: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
    },
    // 导出
    handleExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less"></style>
